import { Routes, Route } from 'react-router-dom'
import { ToastProvider } from '../radix'
import { SaveToListProvider } from '../engineer/favourites/SaveToListProvider'
import { HOME_TAB_ENABLED } from '../../config/features'
import { JobSetup } from '../../pages/engineer/JobSetup'
import { HomePage } from '../../pages/engineer/Home'
import { FavouritesPage } from '../../pages/engineer/Favourites'
import { FavouriteListPage } from '../../pages/engineer/FavouriteList'
import { RecentlyPurchasedPage } from '../../pages/engineer/RecentlyPurchased'
import { SearchPage } from '../../pages/engineer/Search'
import { ProductDetail } from '../../pages/engineer/ProductDetail'
import { SupplierProductDetail } from '../../pages/engineer/SupplierProductDetail'
import { CartPage } from '../../pages/engineer/Cart'
import { SmartCartPage } from '../../pages/engineer/SmartCart'
import { CheckoutPage } from '../../pages/engineer/Checkout'
import { OrderConfirmationPage } from '../../pages/engineer/OrderConfirmation'
import { OrdersPage } from '../../pages/engineer/Orders'
import { OrderDetailPage } from '../../pages/engineer/OrderDetail'
import { MorePage } from '../../pages/engineer/More'
import { EngineerProfilePage } from '../../pages/engineer/Profile'
import { EngineerSecurityPage } from '../../pages/engineer/Security'
import { NotFoundPage } from '../../auth/components/NotFoundPage'

export function EngineerRoutes() {
  return (
    // Engineer toasts sit at the bottom above the nav, in the nav colours
    // (DEV-51010). The Save to list sheet is mounted once here so any
    // heart's "Add to list" toast can open it.
    <ToastProvider variant="engineer">
      <SaveToListProvider>
        <Routes>
          {/* JobSetup is the postcode-entry screen. It stays as the index
           * route so an engineer without a stored postcode lands here first
           * (Noreen 16-07-26: postcode gate takes priority). Once a
           * postcode is present JobSetup itself redirects to /home when
           * the Home tab is enabled, else /search (see JobSetup.tsx). */}
          <Route index element={<JobSetup />} />
          {/* DEV-46921 Home tab + subpages — only registered when the
           * HOME_TAB_ENABLED build flag is on. When off, hitting
           * /home / /favourites / /recently-purchased falls through to
           * the catch-all NotFoundPage below. */}
          {HOME_TAB_ENABLED && (
            <>
              <Route path="home" element={<HomePage />} />
              <Route path="favourites" element={<FavouritesPage />} />
              <Route path="favourites/lists/:listId" element={<FavouriteListPage />} />
              <Route
                path="recently-purchased"
                element={<RecentlyPurchasedPage />}
              />
            </>
          )}
          <Route path="search" element={<SearchPage />} />
          <Route path="product/:masterProductId" element={<ProductDetail />} />
          <Route path="supplier-product/:productId" element={<SupplierProductDetail />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="cart/smart" element={<SmartCartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="order-confirmation" element={<OrderConfirmationPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="order/:orderId" element={<OrderDetailPage />} />
          <Route path="more" element={<MorePage />} />
          <Route path="more/profile" element={<EngineerProfilePage />} />
          <Route path="more/security" element={<EngineerSecurityPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </SaveToListProvider>
    </ToastProvider>
  )
}
